"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthSuitePartnerSubscriptionService = void 0;
var partner_subscription_service_1 = require("./partner-subscription.service");
Object.defineProperty(exports, "AuthSuitePartnerSubscriptionService", { enumerable: true, get: function () { return partner_subscription_service_1.AuthSuitePartnerSubscriptionService; } });
